import React from "react";
import './footer.css'

const currentDate = new Date();

const Footer = () => {
  return (
    <div className="footerholder">
      <div>&copy;{currentDate.getFullYear()} Core2web<sup>®</sup> </div>
      <div style={{ color: "#1675f2" }} className="contact-no">
        Contact: 9665244353 / 9730435300
      </div>
      {/* <div>
        <a
          href="https://www.biencaps.com/"
          target="_blank"
          rel="noopener noreferrer" 
          style={{ textDecoration: "none", color: "#706f6f" }}
        >
          From Biencaps
        </a>
      </div> */}
      <div style={{ color: "#1675f2" }}>core2webinfo@gmail.com</div>
      <div className="footerholder_logo">
        <a
          href="https://www.youtube.com/c/Core2WebTechnologies"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={'/assets/images/footer/youtubelogo.svg'}
            alt="youtubeicon"
            onMouseOver={(e) => {
              e.target.src = "/assets/images/footer/yb-color.svg";
            }}
            onMouseLeave={(e) => {
              e.target.src = "/assets/images/footer/youtubelogo.svg";
            }}
          />
        </a>
        {/*         
        <a
          href="https://www.facebook.com/core2webtechnologies/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <imgo
            src={'/assets/images/footer/facebook-logo.svg'}
            alt="fblogo"
            onMouseOver={(e) => {
              e.target.src = "/assets/images/footer/fb-color.svg";
            }}
            onMouseLeave={(e) => {
              e.target.src = "/assets/images/footer/facebook-logo.svg";
            }}
          />
        </a> */}

        <a
          href="https://www.instagram.com/core2web"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={'/assets/images/footer/insta-logo.svg'}
            alt="instalogo"
            onMouseOver={(e) => {
              e.target.src = "/assets/images/footer/insta-color.svg";
            }}
            onMouseLeave={(e) => {
              e.target.src = "/assets/images/footer/insta-logo.svg";
            }}
          />
        </a>
        <a
          // href="https://www.linkedin.com/in/core2web-27079a191/"
          href="https://www.linkedin.com/company/core2web-technologies/?viewAsMember=true"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={'/assets/images/footer/linkedinlogo.svg'}
            alt="inlogo"
            onMouseOver={(e) => {
              e.target.src = "/assets/images/footer/in-color.svg";
            }}
            onMouseLeave={(e) => {
              e.target.src = "/assets/images/footer/linkedinlogo.svg";
            }}
          />
        </a>
        <a
          href="https://wa.me/+919665244353"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={"/assets/images/footer/whatsappLogo.svg"}
            alt="inlogo"
            onMouseOver={(e) => {
              e.target.src = "/assets/images/footer/whatsappColor.svg";
            }}
            onMouseLeave={(e) => {
              e.target.src = "/assets/images/footer/whatsappLogo.svg";
            }}
          />
        </a>
      </div>
    </div>
  );
};

export default Footer;
